import React, { memo } from 'react'
import { graphql } from 'gatsby'
import { PrismicRichText } from '@prismicio/react'

const Paragraph = ({ slice }) => (
  <div
    className="paragraph"
    style={{ marginTop: `${slice.primary.padding}px` }}
  >
    <PrismicRichText field={slice.primary.paragraph.richText} />
  </div>
)

export default memo(Paragraph)

export const query = graphql`
  fragment StoryPageDataBody1Paragraph16Padding on PrismicStoryPageDataBody1Paragraph16Padding {
    id
    primary {
      padding
      paragraph {
        richText
      }
    }
  }
  fragment ArticlePageDataBodyParagraph16Padding on PrismicArticlePageDataBodyParagraph16Padding {
    id
    primary {
      padding
      paragraph {
        richText
      }
    }
  }
`
